import { useContext } from "react"
import { forwardRef } from "@chakra-ui/react"
import FormContext from "context/FormContext"
import { AuthContext } from "context/AuthContext"
import { filterOptionsBySearchTerm, Searchbox, SearchOption } from "components/Searchbox"
import { CustomSearch } from "api/customSearch"
import { formatSchoolName } from "utilities/formatters";

// I think this should be defined here since this is the only place I think it will be used
// But I could see removing this and defining the object explicitly on the
// CollegeSearchProps in customSearch.ts
export interface CollegeData {
  CollegeName: string
  City: string
  State: string
  CollegeCode: string
}

interface CollegeOption extends SearchOption {
  code: string
}

export const CollegeSearch = forwardRef<any, "div">((props, ref) => {
  const { name, ...rest } = props
  const {
    form: { getValues },
  } = useContext(FormContext)
  const { token } = useContext(AuthContext)
  const formValues = getValues()

  const searchColleges = async (searchTerm = ""): Promise<CollegeOption[]> => {
    if (!token || token === "") return []

    try {
      const response = await CustomSearch.collegeSearch(searchTerm, token)
      if (!response) return []

      const options = response.data.map(
        ({ CollegeName, City, State, CollegeCode }) => {
          return {
            label: formatSchoolName(CollegeName, City, State),
            value: formatSchoolName(CollegeName, City, State),
            code: CollegeCode
          }
        }
      )

      return [
        ...filterOptionsBySearchTerm(options, searchTerm),
        {
          label: "I don't see my school",
          value: "I don't see my school",
          code: "",
        }
      ]
    } catch (error) {
      console.error("Error searching for colleges:", error)
      return []
    }
  }

  return (
    <Searchbox
      ref={ref}
      name={props.name}
      defaultValue={formValues[name]}
      loadOptions={searchColleges}
      {...rest}
    />
  )
})
